import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BsDatepickerModule, ProgressbarModule } from "ngx-bootstrap";
import { DatePickerComponent } from "./date-picker/date-picker.component";
import { SuccessModalComponent } from "./success-modal/success-modal.component";
import { TaxInvoiceModalComponent } from "./tax-invoice-modal/tax-invoice-modal.component";
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressbarModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgSelectModule
  ],
  declarations: [
    DatePickerComponent,
    SuccessModalComponent,
    TaxInvoiceModalComponent
  ],
  exports: [
    DatePickerComponent,
    SuccessModalComponent,
    TaxInvoiceModalComponent
  ],
  providers: [
  ]
})
export class BuilkSharedModule { }
